
import Be from "../../../assets/outline/Be.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BeIcon({ className, dataTestid = "BeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Be data-testid={dataTestid} className={classes} {...rest} />
  );
}
